export default __webpack_public_path__ + "static/media/texture.a663001a.jpg";